import styled from "styled-components";
import { pageMargins, pageMarginsLeft } from "@/lib/styles/helpers";

export const Container = styled.aside`
  ${pageMargins};
  
  margin-top: 1.5rem;
  flex: 1 0 auto;
  display: flex;
  gap: 1.5rem;

  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-size: 0.875rem;
  line-height: 160%;

  *:nth-child(1) {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 700;
  }
  *:nth-child(2) {
    color: rgba(50, 50, 50, 0.64);
  }

  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-top: 2.5rem;
    padding: 0 2.5rem;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    ${pageMarginsLeft};
    padding: 0;
    margin-right: 0 !important;
    grid-column: 1 / 2;
  }

  ${({ theme }) => theme.mediaQueries.desktop} {
    margin-left: 0 !important;
  }
`;
